import { useMemo, useState } from 'react';
import { Link, Rel } from '../../../../../../../Resource/Types';
import { findLinkBy } from '../../../../../../../Links';

export function useLinks(links: ReadonlyArray<Link>) {
  const [initializedLinks] = useState(() => links);

  const getLink = (rel: Rel) => {
    return useMemo(() => findLinkBy({ rel }, initializedLinks), [rel]);
  };

  return { getLink };
}
